import {
  ScrollText, Users, Wrench, Settings, FilePlus2, Hourglass, PackageOpen,
  Truck, PackageCheck, Crown, Heart, Archive, Sparkles, Store, Gift, FileEdit,
  DollarSign, AlertOctagon, Flag, Upload, Package, FlaskConical, Key, Wallet,
} from "lucide-react";

/* The four admin hubs. Each front tile lands on its own sub-dashboard. */
export const SECTIONS = {
  orders: {
    label: "Orders",
    blurb: "Everything from a new order to the courier bag.",
    Icon: ScrollText,
    tile: "#E9D5E3",
    links: [
      { to: "/admin/orders/create", label: "Create Order", Icon: FilePlus2, blurb: "Build a new order by hand" },
      { to: "/admin/payments", label: "Payments", Icon: Wallet, blurb: "Who owes what · remind · mark paid" },
      { to: "/admin/orders/all", label: "All Orders", Icon: ScrollText, blurb: "Every order in one list" },
      { to: "/admin/orders/awaiting-payment", label: "Awaiting Payment", Icon: Hourglass, blurb: "Invoices not yet paid" },
      { to: "/admin/orders/packing", label: "Packing", Icon: PackageOpen, blurb: "Being packed for Management" },
      { to: "/admin/orders/to-ship", label: "Shipping", Icon: Truck, blurb: "Ready for the courier" },
      { to: "/admin/orders/completed", label: "Completed", Icon: PackageCheck, blurb: "Done and dusted" },
      { to: "/admin/orders/complaints", label: "Complaints / Refunds", Icon: AlertOctagon, blurb: "Issues to resolve" },
      { to: "/admin/orders/completed-historical", label: "Completed Historical", Icon: Archive, blurb: "Legacy orders, separate ledger" },
    ],
  },
  customers: {
    label: "Customers",
    blurb: "Your people , profiles, VIPs and wishlists.",
    Icon: Users,
    tile: "#D9BFD4",
    links: [
      { to: "/admin/customers", label: "Customer Database", Icon: Users, blurb: "Profiles, bulk VIP & mass email" },
      { to: "/admin/orders/historical", label: "Historical Customers", Icon: Archive, blurb: "Legacy customer records & folders" },
      { to: "/admin/customers/priority", label: "Flagged Customers", Icon: Flag, blurb: "Marked for follow-up" },
      { to: "/admin/customers/wishlist-heatmap", label: "Wishlist Heatmap", Icon: Heart, blurb: "Most-wanted varieties" },
      { to: "/admin/bulk-import", label: "Bulk Import", Icon: Upload, blurb: "Import orders in one go" },
    ],
  },
  operations: {
    label: "Operations",
    blurb: "Stock, store and the money picture.",
    Icon: Wrench,
    tile: "#F3E2EA",
    links: [
      { to: "/admin/stock", label: "Stock Inventory", Icon: Package, blurb: "Tuber stock levels" },
      { to: "/admin/boxes", label: "Box Inventory", Icon: PackageOpen, blurb: "Mystery & build-a-boxes" },
      { to: "/admin/store-products", label: "Store Products", Icon: Store, blurb: "What's on the shop" },
      { to: "/admin/catalog", label: "Catalogue", Icon: Sparkles, blurb: "The variety catalogue" },
      { to: "/admin/finance", label: "Finance HQ", Icon: DollarSign, blurb: "Sales, cash, owing, refunds & ledger" },
      { to: "/admin/vouchers", label: "Vouchers & Credits", Icon: Gift, blurb: "Heritage credit & codes" },
    ],
  },
  system: {
    label: "System",
    blurb: "The website itself and account keys.",
    Icon: Settings,
    tile: "#E4D3E9",
    links: [
      { to: "/admin/content", label: "Edit Website Content", Icon: FileEdit, blurb: "Text & images on every page" },
      { to: "/admin/test-accounts", label: "Test Accounts", Icon: FlaskConical, blurb: "Safe accounts for trying things" },
      { to: "/admin/reset-password", label: "Reset Password", Icon: Key, blurb: "Change your admin password" },
    ],
  },
};
